import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "layout-main-container pt-8" }
const _hoisted_2 = { class: "layout-main" }
const _hoisted_3 = { class: "card pt-3 pb-3" }
const _hoisted_4 = { class: "card-container blue-container overflow-hidden" }
const _hoisted_5 = { class: "flex" }
const _hoisted_6 = { class: "flex-initial flex align-items-center justify-content-center mr-2" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "flex-initial flex align-items-center m-0 font-medium text-2xl text-900" }, " Información de interés nacional ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toast = _resolveComponent("Toast")!
  const _component_Message = _resolveComponent("Message")!
  const _component_Button = _resolveComponent("Button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_cuadrosVisor = _resolveComponent("cuadrosVisor")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Toast, { id: "toastMsg" }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.error$.mostrar)
          ? (_openBlock(), _createBlock(_component_Message, {
              severity: "error",
              key: _ctx.error$.msg
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.error$.msg), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_router_link, {
                  to: "/",
                  custom: ""
                }, {
                  default: _withCtx(({ navigate }) => [
                    _createVNode(_component_Button, {
                      class: "p-button-rounded mr-2",
                      onClick: navigate,
                      icon: "pi pi-arrow-left"
                    }, null, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _hoisted_7
            ])
          ])
        ]),
        _createVNode(_component_cuadrosVisor, {
          idCuadro: _ctx.id_cuadro,
          conversion_medida: true
        }, null, 8, ["idCuadro"])
      ])
    ])
  ], 64))
}